// eslint-disable-next-line @typescript-eslint/ban-types
export var isObject = function isObject(value) {
  return value !== null && typeof value === 'object';
};